import {useState} from "react";
import { createActivity } from "../api";

export default function MakeActivity ({token, setMakeActivity}) {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const postActivity = async () => {
        try {
            const result = await createActivity(token, name, description)
            console.log(result);
            return result;
        } catch(err) {
            console.error(err)
        }
    }
    return <form className="makeActivity" onSubmit={event => {
        event.preventDefault();
        postActivity();
        setName("");
        setDescription("");
        setMakeActivity(false);
    }}>
        <h2>Create Activity</h2>
        <div className="form-element">
            <label htmlFor="create-title">Name</label>
            <input id="create-name" name="name" value={name} type="text" placeholder="What is the name of your activity?" required onChange={event => {setName(event.target.value)}}/>
        </div>
        <div className="form-element">
            <label htmlFor="create-description">Description</label>
            <textarea id="create-description" name="create-description" value={description} required onChange={event => {setDescription(event.target.value)}}></textarea>
        </div>
        <div className="button-container">
            <button type="submit" className="form-button" >Create</button>
            <button type="button" className="form-button" onClick={((event) => {
                event.preventDefault();
                setMakeActivity(false);
            })}> Cancel</button>
        </div>
    </form> 
}
